var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowSkinny = function SvgArrowSkinny(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5.845a.696.696 0 0 0-.695.695v12.298l-3.697-3.58a.694.694 0 0 0-.984.024.696.696 0 0 0 .026.985l4.871 4.697c.269.255.69.255.959 0l4.872-4.697a.696.696 0 0 0-.959-1.01l-3.696 3.581V1.54A.696.696 0 0 0 6.5.845Z",
    fill: "#2B2F38"
  })));
};

export default SvgArrowSkinny;